import Swal from "sweetalert2";
import { api } from "../api/Middleware";
import {
  CONTACTS_URL,
} from "../api/Urls";

export const GetContact = async (id) => {
  try {
    let response = await api.get(`${CONTACTS_URL}${id}/`);
    return response.data;
  } catch (error) {
    Swal.fire({
      title: "Oops!",
      html: error.response.data,
      icon: "warning",
      toast: true,
      position: "bottom-end",
      timer: 2500,
    });
    return;
  }
};